import {
  AssumptionProperties,
  AssumptionsView,
  ViewContentLayout,
  ViewToolbar,
  ViewWithPropertiesLayout,
} from '@components'
import { useDataModelPageContext } from '@modules/datamodel'
import { useColumnsLayout, useFilterParams } from '@hooks'
import { trpc } from '@services/trpc'
import { useTablePeriodContext } from '@context/TablePeriodContext'
import { CustomPageType } from '@modules/customComputed'
import { AssumptionTableItem } from '@server/interfaces/assumptions'

const rows = [
  {
    id: 'metric_name',
    label: 'Account Metric',
  },
]

interface CustomComputedViewNormalProps {
  type: CustomPageType
}

const CustomComputedViewNormal: React.FC<
  CustomComputedViewNormalProps
> = () => {
  const { selectedDataModel } = useDataModelPageContext()
  const { filters } = useFilterParams()
  const { periods } = useTablePeriodContext()

  const tableQuery = {
    preset: 'metrics',
    options: {
      datamodelId: selectedDataModel?.id,
      periods,
      filters,
      totals: true,
    },
  }

  const {
    data: initialQueryData = [] as AssumptionTableItem[],
    isLoading,
    isFetching,
    refetch,
  } = trpc.api.transactions.tableQuery.useQuery(tableQuery)

  const layout = useColumnsLayout({
    datamodel: null,
    tableQuery,
    rows,
  })

  return (
    <ViewWithPropertiesLayout>
      <ViewContentLayout>
        <ViewToolbar />
        <AssumptionsView
          data={initialQueryData}
          layout={layout}
          isLoading={isLoading}
          isUpdating={isFetching}
          refetch={refetch}
        />
      </ViewContentLayout>

      <AssumptionProperties onRefetch={refetch} />
    </ViewWithPropertiesLayout>
  )
}

export default CustomComputedViewNormal
